<template>
    <sidebar title="Transactions" :show="showTransactionsSidebar" @on-close="close" size="xl">
        <template v-slot:body>
            <div>
                <div class="row mx-1">
                    <div class="col-3 align-items-center">
                        <label>Search</label>
                        <div class="input-group">
                            <span class="input-group-text text-body">
                                <i class="fas fa-search" aria-hidden="true"></i>
                            </span>
                            <input type="text" class="form-control" placeholder="Search Transactions" />
                        </div>

                    </div>
                    <div class="col-3 d-flex align-items-end">
                        <button class="btn bg-gradient-dark mb-0">
                            <i class="fas fa-search"></i>

                            Search
                        </button>
                    </div>
                    <div class="col-6 d-flex align-items-end">
                        <button class="btn bg-gradient-dark mb-0 ms-auto">
                            <i class="fas fa-download"></i>

                            Export
                        </button>
                    </div>
                </div>
                <div class="table-responsive subtransactions">
                    <table class="table main-table">
                        <thead>
                            <tr>
                                <th>Date </th>
                                <th>Dealer </th>
                                <th>Retailer </th>
                                <th>Retailer User </th>
                                <th>Transaction Type </th>
                                <th>Details </th>
                                <th>Amount</th>
                                <th>Reference Number</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="filter-background">
                                <td>
                                    <Datepicker class="form-control p-0 m-0 border" multi-calendars range />
                                </td>
                                <td>
                                    <div class="input-group">
                                        <span class="input-group-text text-body">
                                            <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                        </span>
                                        <input type="text" class="form-control" placeholder="Filter Dealer" />
                                    </div>
                                </td>
                                <td>
                                    <div class="input-group">
                                        <span class="input-group-text text-body">
                                            <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                        </span>
                                        <input type="text" class="form-control" placeholder="Filter Retailer" />
                                    </div>
                                </td>
                                <td>
                                    <div class="input-group">
                                        <span class="input-group-text text-body">
                                            <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                        </span>
                                        <input type="text" class="form-control" placeholder="Filter Retailer User" />
                                    </div>
                                </td>
                                <td>
                                    <div class="input-group">
                                        <span class="input-group-text text-body">
                                            <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                        </span>
                                        <input type="text" class="form-control" placeholder="Filter Type" />
                                    </div>
                                </td>
                                <td>
                                    <div class="input-group">
                                        <span class="input-group-text text-body">
                                            <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                        </span>
                                        <input type="text" class="form-control" placeholder="Filter Details" />
                                    </div>
                                </td>
                                <td>
                                    <div class="input-group">
                                        <span class="input-group-text text-body">
                                            <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                        </span>
                                        <input type="number" class="form-control" placeholder="Filter Amount" />
                                    </div>
                                </td>
                                <td>
                                    <div class="input-group">
                                        <span class="input-group-text text-body">
                                            <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                        </span>
                                        <input type="text" class="form-control" placeholder="Filter Reference" />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    06/01/2025
                                </td>
                                <td>
                                    <div class="d-flex flex-column justify-content-center">
                                        <p class="main-text"> Weecent</p>
                                        <p class="sub-text">12312321312</p>
                                    </div>
                                </td>
                                <td>
                                    <div class="d-flex flex-column justify-content-center">
                                        <p class="main-text"> Weecent</p>
                                        <p class="sub-text">Weecent</p>
                                    </div>
                                </td>
                                <td>
                                    <div class="d-flex flex-column justify-content-center">
                                        <p class="main-text"> <!-- {{ transaction.subRetailerUser.name }} --> Abi Test
                                        </p>
                                        <p class="sub-text"> <!-- {{ transaction.subRetailerUser.username }} -->Abi Test
                                        </p>
                                    </div>
                                </td>
                                <td>
                                    <!-- {{ transaction.type }} --> Abi Test
                                </td>
                                <td>
                                    <!-- {{ transaction.details }} -->Abi Test
                                </td>
                                <td class="text-end">

                                    <span class="badge badge-sm bg-gradient-info">
                                        Php 100.00
                                    </span>
                                    <!-- Php {{ transaction.amount.toFixed(2) }} -->


                                </td>
                                <td>
                                    <!-- {{ transaction.referenceNumber }} --> Abi Test
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>




        </template>
    </sidebar>
</template>

<script>
import sidebar from "../../../../../components/sidebar.vue";
import { mapActions, mapMutations, mapState } from "vuex";

export default {
    components: {
        sidebar,
    },

    methods: {
        close() {
            this.setShowTransactionsSidebar(false);
        },
    },
    computed: {
        ...mapState({
            showTransactionsSidebar: (state) =>
                state.retailerController.showTransactionsSidebar,
        }),

        ...mapMutations({
            setShowTransactionsSidebar: "retailerController/SET_ShowTransactionsSidebar",
            selectSubRetailer: "retailerController/SELECT_SubRetailer",
        }),

    },



};
</script>

<style></style>